import { createSlice } from '@reduxjs/toolkit';
import * as _ from 'lodash';
import {
  MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
  PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD,
} from 'src/constants';
import {
  getNetworksList as getNetworksListPCAdmin,
  searchProviders,
  getPriceComaperFilters,
  getHealthProcedureCodes,
} from './api-calls/priceCompare';
import moment from 'moment';

const INITIAL_STATE = {
  providerType: 'doctor',
  address: '',
  //usercoordinates: {
  //lat: 32.47,
  //lng: -99.7
  //},
  searchParamsForUI: {},
  searchProviderParams: {
    pagesize: 10,
    pagenumber: 1,
    Network: 'all-plan-networks',
    sortby: 'Distance',
    sortdirection: 'asc',
    filters: {
      maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
      Gender: '',
      Provider: 'doctor',
    },
    AcceptingNewPatients: false,
  },
  networksList: [
    { label: 'All Plan Networks', value: 'all-plan-networks' },
    {
      label: 'All - Including Out of Network Providers',
      value: 'all-include-out-of-network',
    },
  ],
  isNetworksListFetched: false,
  isSearchingProviders: false,
  showAllFiltersPanel: false,
  showFilterBar: false,
  filtersValuesList: {},
  searchProviderFiltersChanged: false,
  searchProvidersSortingChanged: false,
  searchResults: { pagination: null, data: null },
  noResultsFound: false,
  showServerError: false,
  selectedCheckedItems: [],
  selectedCheckedRowData: [],
  HealthProcedureCodes: [],
  isHealthProcedureCodesFetched: false,
  recentSearchList: [],
  networkTierList: [],
  showCostClickCount: 0,
  isUpdateTimeExpired: false,
  showCostClickTimestamp: null,
  showCostClickTimeThreshold:
    PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds,
  showCostClickNumThreshold: PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.clicks,
};

export const priceCompareSlice = createSlice({
  name: 'priceCompareAdmin',
  initialState: INITIAL_STATE,
  reducers: {
    setProviderType: (state, action) => {
      state.providerType = action.payload;
      state.searchProviderParams = INITIAL_STATE.searchProviderParams;
      state.searchResults = INITIAL_STATE.searchResults;
      state.showFilterBar = INITIAL_STATE.showFilterBar;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
    },
    setNetworkTierList: (state, action) => {
      state.networkTierList = action.payload;
    },
    resetNetworkTierList: (state, action) => {
      state.networkTierList = INITIAL_STATE.networkTierList;
    },
    setSearchProviderParams: (state, action) => {
      state.searchProviderParams = {
        ...state.searchProviderParams,
        ...action.payload,
      };
    },
    setSearchParamsForUI: (state, action) => {
      state.searchParamsForUI = {
        ...state.searchParamsForUI,
        ...action.payload,
      };
    },
    setSearchProviderSorting: (state, action) => {
      state.searchProviderParams.sortby = action.payload.sortby;
      state.searchProviderParams.sortdirection = action.payload.sortdirection;
      state.searchProvidersSortingChanged = true;
    },
    setShowAllFiltersPanel: (state, action) => {
      state.showAllFiltersPanel = action.payload;
    },
    setSearchProviderFilters: (state, action) => {
      state.searchProviderParams.filters = {
        ...state.searchProviderParams.filters,
        ...action.payload,
      };
      state.searchProviderFiltersChanged = true;
    },
    setFilterChangeStatus: (state, action) => {
      state.searchProviderFiltersChanged = action.payload || false;
    },
    resetSortingChangeStatus: (state, action) => {
      state.searchProvidersSortingChanged = action.payload || false;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setRecentSearchList: (state, action) => {
      state.recentSearchList = action.payload;
    },
    resetSearchParams: (state, action) => {
      Object.keys(INITIAL_STATE).forEach((key) => {
        if (key !== 'networksList') {
          state[key] = INITIAL_STATE[key] || null;
        }
      });
    },
    resetSearchProviderFilters: (state, action) => {
      //state.searchProviderParams = INITIAL_STATE.searchProviderParams;
      const initialSearchProviderParam = JSON.parse(
        JSON.stringify(INITIAL_STATE.searchProviderParams),
      );
      initialSearchProviderParam.Network = state.searchProviderParams.Network;
      initialSearchProviderParam.filters.Provider =
        state.searchProviderParams.filters.Provider;
      if (state.searchProviderParams.DoctorByName) {
        initialSearchProviderParam.DoctorByName =
          state.searchProviderParams.DoctorByName;
      }
      if (state.searchProviderParams.DoctorByType) {
        initialSearchProviderParam.DoctorByType =
          state.searchProviderParams.DoctorByType;
      }
      if (state.searchProviderParams.speciality) {
        initialSearchProviderParam.speciality =
          state.searchProviderParams.speciality;
      }
      if (state.searchProviderParams.facilityname) {
        initialSearchProviderParam.facilityname =
          state.searchProviderParams.facilityname;
      }

      state.searchProviderParams = initialSearchProviderParam;
      //state.searchProviderParams.AcceptingNewPatients = false;
      //state.searchParamsForUI = {};
      state.selectedCheckedItems = [];
      state.selectedCheckedRowData = [];
      state.searchProviderFiltersChanged = true;
      state.showAllFiltersPanel = false;
      state.recentSearchList = [];
    },
    searchProviderFiltersInitial: (state, action) => {
      state.searchProviderParams.filters =
        INITIAL_STATE.searchProviderParams.filters;
      state.searchProviderFiltersChanged = false;
      state.selectedCheckedItems = [];
      state.selectedCheckedRowData = [];
    },
    resettingMoreFilters: (state, action) => {
      //state.searchProviderParams = INITIAL_STATE.searchProviderParams;
      const initialSearchProviderParam = JSON.parse(
        JSON.stringify(INITIAL_STATE.searchProviderParams),
      );
      initialSearchProviderParam.Network = state.searchProviderParams.Network;
      initialSearchProviderParam.filters.Provider =
        state.searchProviderParams.filters.Provider;
      if (state.searchProviderParams.DoctorByName) {
        initialSearchProviderParam.DoctorByName =
          state.searchProviderParams.DoctorByName;
      }
      if (state.searchProviderParams.DoctorByType) {
        initialSearchProviderParam.DoctorByType =
          state.searchProviderParams.DoctorByType;
      }
      if (state.searchProviderParams.speciality) {
        initialSearchProviderParam.speciality =
          state.searchProviderParams.speciality;
      }
      if (state.searchProviderParams.facilityname) {
        initialSearchProviderParam.facilityname =
          state.searchProviderParams.facilityname;
      }

      state.searchProviderParams = initialSearchProviderParam;
      //state.searchProviderParams.AcceptingNewPatients = false;
      state.searchProviderFiltersChanged = true;
      state.selectedCheckedItems = [];
      state.selectedCheckedRowData = [];
      state.showAllFiltersPanel = false;
    },
    resetNetworkList: (state, action) => {
      state.networksList = INITIAL_STATE.networksList;
    },
    resetSearchResults: (state, action) => {
      state.searchResults = INITIAL_STATE.searchResults;
    },
    setSelectedCheckedItems: (state, action) => {
      state.selectedCheckedItems = action.payload;
    },
    reetSelectedCheckedItems: (state, action) => {
      state.selectedCheckedItems = [];
    },

    setSelectedCheckedRowData: (state, action) => {
      state.selectedCheckedRowData = action.payload;
    },
    setShowCostClickCount: (state) => {
      state.showCostClickCount = state.showCostClickCount + 1;
    },
    resetShowCostClickCount: (state) => {
      state.showCostClickCount = 0;
      state.isUpdateTimeExpired = false;
    },
    setShowCostClickTimestamp: (state) => {
      if (state.showCostClickTimestamp === null) {
        state.showCostClickTimestamp =
          moment().unix() +
          parseInt(PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds);
      } else {
        if (
          state.showCostClickTimestamp <
            moment().unix() +
              parseInt(
                PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds,
              ) &&
          state.isUpdateTimeExpired === false
        ) {
          state.showCostClickTimestamp =
            moment().unix() +
            parseInt(
              PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds,
            );
          state.isUpdateTimeExpired = true;
        }
      }
    },
    resetShowCostClickTimestamp: (state) => {
      state.showCostClickTimestamp = null;
      state.isUpdateTimeExpired = false;
    },
  },
  extraReducers: {
    [getNetworksListPCAdmin.fulfilled]: (state, action) => {
      const listOfNetworks = action.payload.data.Response.ListOfNetworks;
      if (listOfNetworks.length === 1) {
        state.searchProviderParams.Network = listOfNetworks[0];
        state.networksList = [
          ...listOfNetworks.map((val) => {
            return { label: val, value: val };
          }),
          state.networksList[1],
        ];
      } else {
        state.networksList = [
          ...state.networksList,
          ...listOfNetworks.map((val) => {
            return { label: val, value: val };
          }),
        ];
      }
      state.isNetworksListFetched = true;
    },
    [getHealthProcedureCodes.fulfilled]: (state, action) => {
      const list = action.payload.data.Response.HealthProcedureCodes;
      state.HealthProcedureCodes = list.map((val) => {
        return { label: val.Abbreviation, value: val.Code };
      });
      state.isHealthProcedureCodesFetched = true;
    },
    [searchProviders.pending]: (state, action) => {
      state.isSearchingProviders = true;
      state.showFilterBar = false;
      state.noResultsFound = false;
      state.showServerError = false;
      state.searchResults = { pagination: null, data: null };
    },
    [searchProviders.fulfilled]: (state, action) => {
      const response = action.payload.data.Response;
      state.searchResults = {
        pagination: response?.Pagination,
        data: response?.data,
      };
      state.isSearchingProviders = false;

      //const resp = response;
      //const filterValue = {};
      //if ( resp && resp !== undefined ) {
      //Object.keys( resp ).forEach( ( key ) => {
      //if(key === "UniqueLanguages" || key === "UniqueSpecialities") {
      //if ( [ 'UniqueLanguages', 'UniqueSpecialities' ].includes( key ) ) {
      //console.log('resp :', resp);
      //filterValue[key] = resp[ key ].map( ele => {
      //return {label: ele, value: ele};
      //} );
      //}
      //}
      //} );
      //}
      //state.filtersValuesList = {Specialities: (filterValue?.UniqueSpecialities ? filterValue?.UniqueSpecialities : []), ListOfDoctorLanguages : (filterValue?.UniqueLanguages ? filterValue?.UniqueLanguages : [])};
      //only for testing starts

      //if (response.data?.length > 0) {
      //state.orgData = response.data;
      //}
      //if (!response.data?.length) {
      //response.data = [...state.orgData];
      //}

      //state.searchResults = { pagination: { ...response.Pagination, TotalRecords: 10 }, data: response.data };
      //only for testing ends

      if (
        _.isEqual(
          state.searchProviderParams.filters,
          INITIAL_STATE.searchProviderParams.filters,
        )
      ) {
        state.showFilterBar = response?.data?.length > 0 ? true : false;
      } else {
        state.showFilterBar = true;
      }
      state.noResultsFound = response?.data?.length > 0 ? false : true;
    },
    [searchProviders.rejected]: (state, action) => {
      state.showFilterBar = false;
      state.isSearchingProviders = false;
      state.searchResults = [];
      if (
        action?.error?.message?.includes('404') ||
        action?.error?.message?.includes('400')
      ) {
        state.noResultsFound = true;
      } else {
        state.showServerError = true;
      }
    },
    [getPriceComaperFilters.pending]: (state, action) => {},
    [getPriceComaperFilters.fulfilled]: (state, action) => {
      const resp = action.payload.data.Response;
      //giving issue with the label values for UniqueSpecialities UniqueLanguages so we are commenting it.

      //if (resp && resp !== undefined) {
      //Object.keys(resp).forEach((key) => {
      //if (['UniqueSpecialities', 'UniqueLanguages'].includes(key)) {
      //resp[key] = resp[key].map((ele) => {
      //return { label: ele, value: ele };
      //});
      //}
      //});
      //}
      state.filtersValuesList = {
        Specialities: resp.UniqueSpecialities,
        ListOfDoctorLanguages: resp.UniqueLanguages,
      };
      //state.filtersValuesList = resp;
    },
    [getPriceComaperFilters.rejected]: (state, action) => {
      state.filtersValuesList = {};
    },
  },
});

export const {
  setSearchProviderParams,
  setAddress,
  setProviderType,
  setSearchResults,
  setShowAllFiltersPanel,
  setSearchProviderFilters,
  resetSearchParams,
  setFilterChangeStatus,
  resetSearchProviderFilters,
  setSearchProviderSorting,
  resetSortingChangeStatus,
  resetNetworkList,
  resetSearchResults,
  searchProviderFiltersInitial,
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
  setSearchParamsForUI,
  reetSelectedCheckedItems,
  resettingMoreFilters,
  setRecentSearchList,
  setNetworkTierList,
  resetNetworkTierList,
  setShowCostClickCount,
  resetShowCostClickCount,
  setShowCostClickTimestamp,
  resetShowCostClickTimestamp,
} = priceCompareSlice.actions;

export default priceCompareSlice.reducer;
